import {
  createRouter,
  createRoute,
  createRootRoute,
  Outlet,
} from "@tanstack/react-router";
import { Layout } from "./components/Layout.js";
import { LoginPage } from "./pages/LoginPage.js";
import { DashboardPage } from "./pages/DashboardPage.js";
import { ProjectsPage } from "./pages/ProjectsPage.js";
import { ProjectDetailPage } from "./pages/ProjectDetailPage.js";
import { KocsPage } from "./pages/KocsPage.js";
import { KocDetailPage } from "./pages/KocDetailPage.js";
import { VideosPage } from "./pages/VideosPage.js";
import { VideoDetailPage } from "./pages/VideoDetailPage.js";
import { JobsPage } from "./pages/JobsPage.js";

const rootRoute = createRootRoute({ component: () => <Outlet /> });

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  component: LoginPage,
});

const layoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "_layout",
  component: () => <Layout><Outlet /></Layout>,
});

const dashboardRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/",
  component: DashboardPage,
});

const projectsRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/projects",
  component: ProjectsPage,
});

const projectDetailRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/projects/$projectId",
  component: ProjectDetailPage,
});

const kocsRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/kocs",
  component: KocsPage,
});

const kocDetailRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/kocs/$kocId",
  component: KocDetailPage,
});

const videosRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/videos",
  component: VideosPage,
});

const videoDetailRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/videos/$videoId",
  component: VideoDetailPage,
});

const jobsRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/jobs",
  component: JobsPage,
});

const routeTree = rootRoute.addChildren([
  loginRoute,
  layoutRoute.addChildren([
    dashboardRoute,
    projectsRoute,
    projectDetailRoute,
    kocsRoute,
    kocDetailRoute,
    videosRoute,
    videoDetailRoute,
    jobsRoute,
  ]),
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
